// import { apis, serverCall } from "../../utils/api/constant";
import { apis, serverCall } from "../../utils/api/constant";
import { baseUrl } from "../../utils/api/constant";
import { getSubCategoryData, setSubCategoryData } from "../../utils/utility";
import {
  fetchDashboardDataSuccess,
  fetchSubCategorySuccess,
  fetchSupplierCategorySuccess,
  PostBulkUpload,
  FetchProcessData,
  FetchStatusUpload
} from "./action";
import { BulkUpload } from "./BulkUpload";
import { logOut } from "../../Logout";
import axios from "axios";

// dispatch.js

console.log(apis)
export const bulkuploading = (formData, userData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "BULK_UPLOAD_REQUEST" });

      const response = await axios.post( baseUrl+apis.UPLOAD_BULKUPLOAD_DATA, formData, {
        headers: {
          "Content-Type": "multipart/form-data", // This is optional; Axios auto-sets it
          "sid":userData.token
        },
      });

      dispatch({
        type: "BULK_UPLOAD_SUCCESS",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "BULK_UPLOAD_FAILURE",
        payload: error.message,
      });
    }
  };
};


// export const bulkuploading = (userData, userName,selectedId,selectedProcess) => {
//   return async (dispatch, getState) => {
//     try {
//       let response = await serverCall(
//         apis.UPLOAD_BULKUPLOAD_DATA,
//         "POST",
//         { userName: userName?.pDATASET[0]?.USERNAME,
//           state:userName?.pDATASET[0]?.STATE_NAME,
//           district:userName?.pDATASET[0]?.CIRCLE_NAME, 
//           circleCode:userName?.pDATASET[0]?.CIRCLE_CODE, 
//           circleId:userName?.pDATASET[0]?.CIRCLE_ID, 
//           processId:selectedId,
//           processName:selectedProcess,
//           file: userData.name,
//           data:userData.name,
//         },
//         { "Content-Type": "multipart/form-data",
//         },
//         { sid: userName.token }
//       );
//       if (!response?.data?.ERROR_STATUS) {

//        // logOut(response.data); // Run logout function on error
//       }
//       if (response.success) {
//         dispatch(PostBulkUpload(response.data));
//       } else {
//         // dispatch(fetchDataFailure(response?.data?.ERROR_MSG));
//       }
//     } catch (error) {}
//   };
// };


export const bulkUploadFetch = (userName) => {

  return async (dispatch, getState) => {
    try {
      let response = await serverCall(
        apis.FETCH_BULK_PROCESS_DATA,
        "POST",
        // { userName: userName?.pDATASET[0]?.USERNAME, data: userData },
        { 	"userName": userName?.pDATASET[0]?.USERNAME, 	"apiID": 1, 	"param1": 0, 	"param2": 0, 	"param3": 0, 	"param4": "", 	"param5": "", 	"param6": "" },
        { sid: userName.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
      //  logOut(response.data); // Run logout function on error
      }
      if (response.success) {

        dispatch(FetchProcessData(response))
        // dispatch(PostBulkUpload(response.data));
      } 
    } catch {}
  };
};



export const FetchUploadStatus = (userName) => {
  return async (dispatch, getState) => {
    try {
      let response = await serverCall(
        apis.FETCH_BULK_PROCESS_DATA,
        "POST",
        // { userName: userName?.pDATASET[0]?.USERNAME, data: userData },
        { 	"userName": userName?.pDATASET[0]?.USERNAME, 	"apiID": 2, 	"param1": 0, 	"param2": 0, 	"param3": 0, 	"param4": "", 	"param5": "", 	"param6": "" },
        { sid: userName.token }
      );
      if (!response?.data?.ERROR_STATUS) {
        console.log(response.data);
      //  logOut(response.data); // Run logout function on error
      }
      if (response.success) {

        dispatch(FetchStatusUpload(response))
        // dispatch(PostBulkUpload(response.data));
      } 
    } catch {}
  };
};